export const FETCH_SITE_USER_REQUEST = '@siteUser/FETCH_SITE_USER_REQUEST';
export const FETCH_SITE_USER_SUCCESS = '@siteUser/FETCH_SITE_USER_SUCCESS';
export const FETCH_SITE_USER_FAILURE = '@siteUser/FETCH_SITE_USER_FAILURE';
